import { cn } from '../../../lib/utils';
import { SupportUserSearchResult } from '../../../services/supportApi';

interface UserInfoCardProps {
  user: SupportUserSearchResult;
}

function StatusBadge({ online }: { online: boolean }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
        online
          ? 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400'
          : 'bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))]'
      )}
    >
      <span className={cn('h-2 w-2 rounded-full', online ? 'bg-emerald-500' : 'bg-gray-400')} />
      {online ? 'Online' : 'Offline'}
    </span>
  );
}

export function UserInfoCard({ user }: UserInfoCardProps) {
  return (
    <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5 space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold text-[hsl(var(--foreground))]">{user.fullName}</h3>
          <p className="text-sm text-[hsl(var(--muted-foreground))]">{user.email}</p>
        </div>
        <StatusBadge online={user.isOnline} />
      </div>

      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Organization</dt>
          <dd className="font-medium">{user.organizationName}</dd>
        </div>
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Org Code</dt>
          <dd className="font-mono text-xs">{user.organizationCode}</dd>
        </div>
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Portal Status</dt>
          <dd className="capitalize">{user.portalStatus}</dd>
        </div>
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Session Status</dt>
          <dd className="capitalize">{user.sessionStatus || 'None'}</dd>
        </div>
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Last Active</dt>
          <dd>{user.lastActive ? new Date(user.lastActive).toLocaleString() : user.lastLogin ? new Date(user.lastLogin).toLocaleString() : '—'}</dd>
        </div>
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Device / Browser</dt>
          <dd>{[user.device, user.browser].filter(Boolean).join(' · ') || '—'}</dd>
        </div>
        <div className="sm:col-span-2">
          <dt className="text-[hsl(var(--muted-foreground))]">IP Address</dt>
          <dd className="font-mono text-xs">{user.ip || '—'}</dd>
        </div>
      </dl>
    </div>
  );
}
